import { buildAppointmentDisplayTitle, resolveSessionAppointmentTitle } from '@/pages/appointments/utils/buildAppointmentDisplayTitle';
import type { ProviderCalendarEventCategory } from './types';

export type AppointmentEditorSource = 'calendar' | 'appointment-page' | 'session-sidebar';

export function appointmentEditorNav(source: AppointmentEditorSource, appointmentId: string): {
  label: string;
  href: string;
} | null {
  if (!appointmentId) return null;
  if (source === 'calendar') {
    return {
      label: 'View appointment',
      href: `/dashboard/appointments/${appointmentId}`,
    };
  }
  if (source === 'appointment-page') {
    return {
      label: 'View in calendar',
      href: `/dashboard/calendar?eventId=${appointmentId}`,
    };
  }
  return null;
}

export function appointmentEditorTitle(input: {
  category?: ProviderCalendarEventCategory | string;
  groupDisplayName?: string | null;
  episodeDisplayName?: string | null;
  episodeTypeName?: string | null;
  sessionTypeDisplay?: string | null;
  existingTitle?: string | null;
  clientDisplayName?: string | null;
  editing?: boolean;
  fallback?: string;
}): string {
  if (input.category === 'meeting') return 'Meeting';
  if (input.category === 'time-entry') return 'Time Entry';
  if (input.category === 'group') {
    return buildAppointmentDisplayTitle({
      groupDisplayName: input.groupDisplayName,
      fallback: input.fallback ?? 'Group Session',
    });
  }
  return resolveSessionAppointmentTitle({
    episodeDisplayName: input.episodeDisplayName,
    episodeTypeName: input.episodeTypeName,
    sessionTypeDisplay: input.sessionTypeDisplay,
    existingTitle: input.existingTitle,
    clientDisplayName: input.clientDisplayName,
    fallback: input.fallback ?? (input.editing ? 'Session' : 'New Event'),
  });
}
